import styled from '@emotion/styled'
import { CartTitle } from '../Cart'
import { CartType } from '../Cart/Cart'
import { LineBreak } from '../Shop/commonStyles'
import { StyledHTMLElement } from 'shop/theme/types'

const CartModalHeader = () => {
  return (
    <>
      <CartTitleContainer>
        <CartTitle type={CartType.Cart} />
      </CartTitleContainer>
      <LineBreakContainer>
        <LineBreak height={'2px'} />
      </LineBreakContainer>
    </>
  )
}

const CartTitleContainer = styled.div({
  marginBottom: '21px'
})

const LineBreakContainer = styled.div<StyledHTMLElement & { margin?: string }>(
  ({ margin = '0 -16px 0px' }) => ({
    margin: margin
  })
)

export default CartModalHeader
